var b = document.documentElement; 
b.setAttribute('data-useragent',  navigator.userAgent);
b.setAttribute('data-platform', navigator.platform);

$(function(){
	$('.nav-collapse').css('width', ($('footer').width()+1)).css('margin-left', '-1px');
});

$('.slider').glide({
    autoplay: 5000,
    arrows: false,
    navigation: false,
    type: 'slideshow',
    forceJS: true,
    circular: true
});

$(function(){
	if(navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*CPU.*OS 7_\d/i)){
		$('#slider').removeClass('slider');
		var i = Math.floor(Math.random() * 3) + 1;
		$('#slider').html('<figure><img class="slider__item" src="/images/slide/'+i+'.jpg" style="width: 100%"></figure>');
	}

	var isAndroid = navigator.userAgent.toLowerCase().indexOf("android");
  	if(isAndroid > -1)
  	{
  		$('#slider').removeClass('slider');
		var i = Math.floor(Math.random() * 3) + 1;
		$('#slider').html('<figure><img src="/images/slide/'+i+'.jpg" style="max-width: auto; width: 100%; height: auto"></figure>');
  	}
});

if(!document.createElement('svg').getAttributeNS){
  $('#logoijsmakers').attr('src', '/images/logo.jpg');
}

$.extend(true, $.magnificPopup.defaults, {
	tClose: 'Sluit (Esc)',
	tLoading: 'Aan het laden...',
	gallery: {
		preload: [0,2],
		navigateByImgClick: true,
		tPrev: 'Vorige (pijl naar links)',
		tNext: 'Volgende (pijl naar rechts)',
		tCounter: '<span class="mfp-counter">%curr%/%total%</span>'
	},
	image: {
		tError: '<a href="%url%">De afbeelding</a> kan niet worden geladen',
	}
});

$(document).on('click', '.toggle', function(){
	$('.mobile ul').slideToggle();
})

$(function(){
	$('header nav a').each(function(index, value) { 
		$this = $(this);
		if($this.attr('href') == $('#nav').data('active')){
			$this.addClass('active').addClass('selected');
		}
		
	});

	// if($('header nav a').eq(0).hasClass('active')) { 
	// 	$('.nav-collapse').css('width', $('.mapje').width());
	// }

	$('.magnific').magnificPopup({
		type: 'image',
		gallery:{
			enabled:true
		}
	});
});
function layzr()
{
	var layzr = new Layzr({ 
		attr: 'data-layzr', 
		//retinaAttr: 'data-layzr-retina', 
		threshold: 3000, 
		callback: function() { 
			//console.info(this.offsetWidth);
	    	this.classList.add('ijsmakers'); 
	    	$('.overlay').css('width', this.width).css('height', this.height);
	    	$('.overlay').next().css('margin-top', '-'+this.height+'px');
	    	//$('.overlay').parent().css('width', this.width).css('height', this.height);
	  	} 
	});

	var isAndroid = navigator.userAgent.toLowerCase().indexOf("android");
  	if(isAndroid > -1)
  	{
  		$('img[data-layzr]').each(function(index, value) { 
  			$(this).attr('src', $(this).data('data-layzr-retina'));
  		});

  		$( window ).load(function() {
	       $('img[data-layzr]').each(function(index, value) { 
	  			$(this).attr('src', $(this).data('data-layzr-retina'));
	  		});
	    });
  	}




} layzr(); 

window.requestAnimFrame = (function() { 
  return window.requestAnimationFrame || 
         window.webkitRequestAnimationFrame || 
         window.mozRequestAnimationFrame || 
         function(callback) { 
           window.setTimeout(callback, 1000 / 60); 
         }; 
})();

$(window).scroll(function(){
    //Shownavigation navigation
    var aboveHeight = $('header').outerHeight();
    if ($(window).scrollTop() > aboveHeight){
        $('header').addClass('show').next();
    } else {
        $('header').removeClass('show').next();
    }
});


window.addEventListener("orientationchange", function() {
  if(window.orientation == 90){
  	location.reload();
  }	
  if(window.orientation == -90){
  	location.reload();
  }
}, false);

$(window).resize(function() {
	layzr(); 
});
window.onorientationchange = function() {
	layzr(); 
}